import { useCallback, useMemo, useRef } from 'react'

import { ModalPriority, ModalTypes, useModalManager } from '@wwt/core/modals'
import { ReasonType } from '@wwt/entities/reason'

export const useReasonReview = () => {
	const showModal = useModalManager.use.showModal()
	const closeModal = useModalManager.use.closeModal()

	const reasonReviewId = useRef<string | null>(null)

	const handleCloseModal = useCallback(
		(onClose: () => void, withCloseReason = true) => {
			if (reasonReviewId.current === null) {
				throw new Error('Something went wrong in reason review')
			}

			closeModal(reasonReviewId.current)
			reasonReviewId.current = null

			if (withCloseReason) {
				onClose()
			}
		},
		[closeModal, reasonReviewId]
	)

	const onOpenReview = useCallback(
		(onClose: () => void, offerId: string, type: ReasonType) => {
			reasonReviewId.current = showModal(
				ModalTypes.ReasonReview,
				{
					onConfirm: () => handleCloseModal(onClose, true),
					type,
					offerId
				},
				ModalPriority.default,
				{
					onClose: () => handleCloseModal(onClose, false)
				}
			)
		},
		[reasonReviewId, showModal]
	)

	return useMemo(
		() => ({
			onOpenReview
		}),
		[onOpenReview]
	)
}
